import React, { useMemo, useCallback } from 'react';
import { isFavorite, isComplete, isVerified } from '../utils/lists_helper';
import { setActiveModal } from '../ducks/modals';
import { useDispatch } from 'react-redux';
import { SAVE_TO_LIST } from '../constants';

const useReduxListItems = ({ type, ID }, listItems) => {
  const dispatch = useDispatch();

  const handleFavoriteClick = useCallback(() => {
    dispatch(setActiveModal(SAVE_TO_LIST, { type, ID }));
  }, [listItems, type, ID]);

  return useMemo(() => {
    return {
      isFavorite: isFavorite(type, ID, listItems),
      isVerified: isVerified(type, ID, listItems),
      isCompleted: isComplete(type, ID, listItems),
      handleFavoriteClick
    };
  }, [listItems, type, ID]);
};

export default useReduxListItems;
